import { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function CreateCS() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    title: "CS 2V2 BATTLE 😈🔥(ORION,A124 AND RYDEN BAN)",
    map: "Bermuda",
    mode: "Clash Squad",
    team: "Duo",
    entryFee: "",
    totalSpots: 4,
    perKill: 0,
    prizePool: 0,
    time: "",
  });

  const teamOptions = ["Duo", "Solo"];
  const spotOptions = form.team === "Duo" ? [2, 4] : [2];

  const handle = (e) => {
    const { name, value } = e.target;

    let updated = { ...form, [name]: value };

    if (name === "team") {
      updated.totalSpots = value === "Duo" ? 4 : 2;
    }

    const entry = Number(updated.entryFee);
    const spots = Number(updated.totalSpots);

    if (entry > 0) {
      const total = entry * spots;
      const prize = total - total * 0.2;
      updated.prizePool = Math.floor(prize);
    } else {
      updated.prizePool = 0;
    }

    setForm(updated);
  };

  const create = async () => {
    if (!form.title || !form.entryFee) {
      alert("Fill all fields");
      return;
    }

    setLoading(true);

    const spotsLeft =
      form.team === "Duo" ? [2, 2] : [1, 1];

    await addDoc(collection(db, "cs_tournaments"), {
      ...form,
      entryFee: Number(form.entryFee),
      totalSpots: Number(form.totalSpots),
      perKill: Number(form.perKill),
      prizePool: Number(form.prizePool),
      spotsLeft,
      createdAt: new Date(),
      winnerDeclared: false,
      status: "upcoming",
      roomID: "Coming Soon",
      roomPass: "Coming Soon",
      time: form.time ? new Date(form.time) : new Date(),
    });

    setLoading(false);
    alert("Tournament Created ✅");
    navigate("/cs");
  };

  return (
    <div style={container}>
      <div style={card}>
        <h2 style={title}>➕ Create CS Tournament</h2>

        <Input
          label="Title"
          name="title"
          value={form.title}
          onChange={handle}
          placeholder="Enter match title"
        />

        <Input
          label="Map"
          name="map"
          value={form.map}
          onChange={handle}
          placeholder="Bermuda"
        />

        <Input
          label="Mode"
          name="mode"
          value={form.mode}
          onChange={handle}
          placeholder="Clash Squad"
        />

        {/* TEAM */}
        <div>
          <label style={label}>Team Type</label>
          <select
            name="team"
            value={form.team}
            onChange={handle}
            style={input}
          >
            {teamOptions.map((t) => (
              <option key={t}>{t}</option>
            ))}
          </select>
        </div>

        <Input
          label="Entry Fee (₹)"
          type="number"
          name="entryFee"
          value={form.entryFee}
          onChange={handle}
          placeholder="Enter entry fee"
        />

        {/* SPOTS */}
        <div>
          <label style={label}>Total Spots</label>
          <select
            name="totalSpots"
            value={form.totalSpots}
            onChange={handle}
            style={input}
          >
            {spotOptions.map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
        </div>

        <Input
          label="Per Kill (Manual)"
          name="perKill"
          type="number"
          value={form.perKill}
          onChange={handle}
          placeholder="Optional"
        />

        <Input
          label="Prize Pool (Auto)"
          value={form.prizePool}
          readOnly
        />

        <Input
          label="Match Time"
          type="datetime-local"
          name="time"
          value={form.time}
          onChange={handle}
        />

        <button onClick={create} style={btn}>
          {loading ? "Creating..." : "🚀 Create Tournament"}
        </button>
      </div>
    </div>
  );
}

/* 🔥 INPUT COMPONENT */
function Input({ label, ...props }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={labelStyle}>{label}</label>
      <input {...props} style={input} />
    </div>
  );
}

/* 🔥 STYLES */

const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
};

const card = {
  background: "#1E2235",
  padding: 25,
  borderRadius: 14,
  display: "flex",
  flexDirection: "column",
  gap: 14,
  width: 360,
  color: "#fff",
  boxShadow: "0 0 20px rgba(0,0,0,0.4)",
};

const title = {
  textAlign: "center",
};

const labelStyle = {
  fontSize: 12,
  color: "#9CA3AF",
};

const label = {
  fontSize: 12,
  color: "#9CA3AF",
  marginBottom: 4,
};

const input = {
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #2D334A",
  background: "#111827",
  color: "#fff",
  outline: "none",
};

const btn = {
  marginTop: 10,
  padding: 12,
  border: "none",
  borderRadius: 10,
  background: "#2563EB",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "bold",
};

export default CreateCS;